export const leaveFor = (url: string) => window.location.assign(url);
